import AppRouter from "./routes/Router";
import { useSelector } from "react-redux";
import { RootState } from "./redux/Store";

function App() {
  const theme = useSelector(
    (state: RootState) => state.preference.systemPreference.theme
  );

  return (
    <div className={theme}>
      <AppRouter />
    </div>
  );
}

export default App;
